export default "__VITE_ASSET__CeNoD0TR__"